import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardContent,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Menu,
  Modal,
  Box,
  Container,
  Divider,
  ListItemIcon,
  Breadcrumbs,
  Link,
  useTheme,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ArticleIcon from "@mui/icons-material/Article";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import HomeIcon from "@mui/icons-material/Home";
import GroupsOutlined from "@mui/icons-material/GroupsOutlined";
import Restricted from "components/Restricted";

const GestionBoletin = () => {
  const [items, setItems] = React.useState([]);

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("token"));
    if (items) {
      setItems(items);
    }
  }, []);

  const rol = items.rol;

  const nav = useNavigate();

  //Theme
  const theme = useTheme();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "100%", sm: "80vw" },
    height: { xs: "100%", sm: "90vh" },
    bgcolor: "background.paper",
    boxShadow: 24,
    border: { xs: 0 },
    borderRadius: { xs: 0, sm: 4 },
    p: { xs: 2, sm: 3, md: 4 },
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.palette.background.alt,
  };

  // --- ESTADOS Y LÓGICA (sin cambios) ---
  const [boletines, setBoletines] = useState([
    {
      id: 1,
      year: 2025,
      month: 1,
      name: "Boletín Enero 2025",
      file: null,
      fileUrl: "/path/to/dummy1.pdf",
    },
    {
      id: 2,
      year: 2025,
      month: 2,
      name: "Boletín Febrero 2025",
      file: null,
      fileUrl: "/path/to/dummy2.pdf",
    },
    {
      id: 3,
      year: 2025,
      month: 3,
      name: "Boletín Marzo 2025",
      file: null,
      fileUrl: "/path/to/dummy3.pdf",
    },
  ]);
  const [filteredBoletines, setFilteredBoletines] = useState(boletines);
  const [selectedYear, setSelectedYear] = useState("all");
  const [selectedMonth, setSelectedMonth] = useState("all");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedBoletin, setSelectedBoletin] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [previewFileUrl, setPreviewFileUrl] = useState("");

  const monthNames = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];

  const getYears = () => {
    const years = new Set(boletines.map((b) => b.year));
    const currentYear = new Date().getFullYear();
    years.add(currentYear);
    return Array.from(years).sort();
  };

  const getAvailableMonths = (year) => {
    const months = new Set();
    boletines.forEach((boletin) => {
      if (boletin.year === year) {
        months.add(boletin.month);
      }
    });
    return Array.from(months).sort((a, b) => a - b);
  };

  useEffect(() => {
    let result = boletines;
    if (selectedYear !== "all") {
      result = result.filter((b) => b.year === selectedYear);
    }
    if (selectedMonth !== "all") {
      result = result.filter((b) => b.month === selectedMonth);
    }
    setFilteredBoletines(result);
  }, [selectedYear, selectedMonth, boletines]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const currentMonth = new Date().getMonth() + 1;
      const currentYear = new Date().getFullYear();
      const exists = boletines.some(
        (b) => b.year === currentYear && b.month === currentMonth
      );
      if (exists) {
        alert(
          `Ya existe un boletín para ${
            monthNames[currentMonth - 1]
          } de ${currentYear}.`
        );
        return;
      }
      const newBoletin = {
        id: Date.now(),
        year: currentYear,
        month: currentMonth,
        name: `Boletín ${monthNames[currentMonth - 1]} ${currentYear}`,
        file: file,
        fileUrl: URL.createObjectURL(file),
      };
      setBoletines([...boletines, newBoletin].sort((a, b) => b.id - a.id));
    }
  };

  const handleUploadClick = () => document.getElementById("fileInput").click();
  const handleMenuClick = (event, boletin) => {
    setAnchorEl(event.currentTarget);
    setSelectedBoletin(boletin);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedBoletin(null);
  };
  const handleDelete = () => {
    setBoletines(boletines.filter((b) => b.id !== selectedBoletin.id));
    handleMenuClose();
  };
  const handlePreview = () => {
    setPreviewFileUrl(selectedBoletin.fileUrl);
    setOpenModal(true);
    handleMenuClose();
  };
  const handleCloseModal = () => setOpenModal(false);

  //Routes
  const handleLinkHome = (event, message) => {
    event.preventDefault();
    if (message === "home") {
      nav("/inicio");
    }
  };

  const handleLinkGestion = (event, message) => {
    event.preventDefault();
    if (message === "gestion") {
      nav("/gestionhumana");
    }
  };

  // --- RENDERIZADO DEL COMPONENTE ---
  return (
    <Box m={{ xs: "1.5rem 0.5rem", sm: "1.5rem 2.5rem" }}>
      {rol === "1" || rol === "2" || rol === "7" ? (
        <Box role="presentation" sx={{ mb: 3, px: { xs: 2, sm: 0 } }}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link
              underline="hover"
              sx={{ display: "flex", alignItems: "center" }}
              color="inherit"
              href="/inicio"
              onClick={(event) => handleLinkHome(event, "home")}
            >
              <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
              Inicio
            </Link>
            <Link
              underline="hover"
              sx={{ display: "flex", alignItems: "center" }}
              color="inherit"
              href="/gestionhumana"
              onClick={(event) => handleLinkGestion(event, "gestion")}
            >
              <GroupsOutlined sx={{ mr: 0.5 }} fontSize="inherit" />
              Gestión Humana
            </Link>
            <Typography
              sx={{ display: "flex", alignItems: "center" }}
              color="text.primary"
            >
              <ArticleIcon sx={{ mr: 0.5 }} fontSize="inherit" />
              Gestión de Boletines
            </Typography>
          </Breadcrumbs>
          <Typography variant="h3" sx={{ fontWeight: "bold", mt: 2 }}>
            Gestión de Boletines
          </Typography>
          <Container maxWidth="lg" sx={{ mt: 4, px: { xs: 0 } }}>
            <Card
              sx={{
                borderRadius: 4,
                bgcolor: theme.palette.background.alt,
              }}
            >
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    justifyContent: { sm: "space-between" },
                    alignItems: "center",
                    gap: 2,
                    mb: 3,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      width: { xs: "100%", sm: "40%" },
                    }}
                  >
                    <FormControl sx={{ flexGrow: 1 }}>
                      <InputLabel>Año</InputLabel>
                      <Select
                        value={selectedYear}
                        label="Año"
                        onChange={(e) => {
                          setSelectedYear(e.target.value);
                          setSelectedMonth("all");
                        }}
                      >
                        <MenuItem value="all">
                          <em>Todos</em>
                        </MenuItem>
                        {getYears().map((year) => (
                          <MenuItem key={year} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl
                      sx={{ flexGrow: 1 }}
                      disabled={selectedYear === "all"}
                    >
                      <InputLabel>Mes</InputLabel>
                      <Select
                        value={selectedMonth}
                        label="Mes"
                        onChange={(e) => setSelectedMonth(e.target.value)}
                      >
                        <MenuItem value="all">
                          <em>Todos</em>
                        </MenuItem>
                        {selectedYear !== "all" &&
                          getAvailableMonths(selectedYear).map((month) => (
                            <MenuItem key={month} value={month}>
                              {monthNames[month - 1]}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Box>
                  <Box sx={{ width: { xs: "100%", sm: "auto" } }}>
                    <input
                      type="file"
                      id="fileInput"
                      hidden
                      onChange={handleFileChange}
                      accept="application/pdf"
                    />
                    <Button
                      variant="contained"
                      size="large"
                      onClick={handleUploadClick}
                      startIcon={<FileUploadIcon />}
                      sx={{
                        width: "100%",
                        bgcolor: "teal",
                        color: "white",
                        "&:hover": { bgcolor: "darkcyan", color: "white" },
                      }}
                    >
                      Subir Boletín
                    </Button>
                  </Box>
                </Box>
                <Divider sx={{ width: "97%", mx: "auto", my: 2 }} />
                <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
                  <ArticleIcon sx={{ color: "text.secondary", mr: 1 }} />
                  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    Histórico de Boletines
                  </Typography>
                </Box>
                {filteredBoletines.length > 0 ? (
                  <List>
                    {filteredBoletines.map((boletin) => (
                      <ListItem
                        key={boletin.id}
                        divider
                        secondaryAction={
                          <IconButton
                            edge="end"
                            aria-label="opciones"
                            onClick={(e) => handleMenuClick(e, boletin)}
                          >
                            <MoreVertIcon />
                          </IconButton>
                        }
                      >
                        <ListItemIcon>
                          <ArticleOutlinedIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary={boletin.name}
                          secondary={`Subido para: ${
                            monthNames[boletin.month - 1]
                          } ${boletin.year}`}
                        />
                      </ListItem>
                    ))}
                  </List>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      p: 4,
                      color: "text.secondary",
                    }}
                  >
                    <InfoOutlinedIcon sx={{ fontSize: 40, mb: 1 }} />
                    <Typography>
                      No se encontraron boletines con los filtros seleccionados.
                    </Typography>
                  </Box>
                )}
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                >
                  <MenuItem onClick={handlePreview}>
                    <ListItemIcon>
                      <VisibilityIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Vista Previa</ListItemText>
                  </MenuItem>
                  <MenuItem onClick={handleDelete} sx={{ color: "error.main" }}>
                    <ListItemIcon>
                      <DeleteIcon
                        fontSize="small"
                        sx={{ color: "error.main" }}
                      />
                    </ListItemIcon>
                    <ListItemText>Eliminar</ListItemText>
                  </MenuItem>
                </Menu>
                <Modal
                  open={openModal}
                  onClose={handleCloseModal}
                  aria-labelledby="modal-title"
                >
                  <Box sx={style}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <FindInPageIcon sx={{ mr: 1, fontSize: "2rem" }} />
                      <Typography
                        id="modal-title"
                        variant="h6"
                        component="h2"
                        sx={{ fontWeight: "bold" }}
                      >
                        Vista Previa del Boletín
                      </Typography>
                    </Box>
                    <iframe
                      src={previewFileUrl}
                      title="Vista Previa del Boletín"
                      style={{
                        width: "100%",
                        height: "100%",
                        border: "none",
                        flexGrow: 1,
                        marginTop: "16px",
                      }}
                    >
                      <p>Tu navegador no soporta la previsualización de PDF.</p>
                    </iframe>
                    <Box
                      sx={{
                        mt: 2,
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Button
                        onClick={handleCloseModal}
                        variant="contained"
                        color="error"
                      >
                        Cerrar
                      </Button>
                    </Box>
                  </Box>
                </Modal>
              </CardContent>
            </Card>
          </Container>
        </Box>
      ) : (
        <Restricted />
      )}
    </Box>
  );
};

export default GestionBoletin;
